/**
 * Created by Andrey Popov on 07.06.2021
 */

const LivesMenuBarItemModel = function (config) { 
    MenuBarItem.call(this, config);
};

LivesMenuBarItemModel.prototype = Object.create(MenuBarItem.prototype);
LivesMenuBarItemModel.prototype.constructor = LivesMenuBarItemModel;

LivesMenuBarItemModel.prototype.customInit = function () {
    runCleaners(this);

    this.lives = cleverapps.lives;

    this.attention = false;

    this.lives.on("changeAmount", this.updateAll.bind(this), this);
    this.lives.on("startRegenerate", this.updateAll.bind(this), this);
    this.lives.on("buyUnlimitedLives", this.updateAll.bind(this), this);

    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.energyLottery) {
        Map2dLocation.currentLocation.energyLottery.onShowHint = this.setFinger.bind(this, true);
        Map2dLocation.currentLocation.energyLottery.onHideHint = this.setFinger.bind(this);
    }

    this.updateAll();
};

LivesMenuBarItemModel.prototype.onAction = function () {
    this.setFinger(false);
};

LivesMenuBarItemModel.prototype.getTargetTypes = function () {
    if (cleverapps.lives && cleverapps.lives.isWithEnergy()) {
        return cleverapps.lives.locationConfig.withOwnLives ? ["energy", "expeditionEnergy"] : "energy";
    }

    return MenuBarItem.prototype.getTargetTypes.call(this);
};

LivesMenuBarItemModel.prototype.hasUnlimitedLives = function () {
    if (!cleverapps.unlimitedLives || !cleverapps.unlimitedLives.checkBuyed()) {
        return false;
    }

    return this.lives && this.lives.hasUnlimitedLives();
};

LivesMenuBarItemModel.prototype.withPlusButton = function () {
    if (this.hasUnlimitedLives()) {
        return false;
    }

    return MenuBarItem.prototype.withPlusButton.call(this);
};

LivesMenuBarItemModel.prototype.updateAll = function (withoutDelta) {
    if (this.hasUnlimitedLives()) {
        this.totalIcon = bundles.menubar.frames.unlim_png;
    } else {
        this.totalIcon = false;
    }

    this.changeText(withoutDelta);

    this.updatePlusButton();
    this.updateTimer();
    this.updateAttention();
};

LivesMenuBarItemModel.prototype.updateTimer = function () {
    const timer = this.timer;

    this.stopTimer();

    this.lottery = !["merge", "merge2"].includes(cleverapps.config.type);
    if (this.hasUnlimitedLives()) {
        this.lottery = false;
        this.setTimer(new cleverapps.CountDown(cleverapps.unlimitedLives.getLeftTime(), {
            onFinish: function () {
                this.updateAll();
            }.bind(this)
        }), false);
    } else if (this.lives.amount < this.lives.getMaxLives() && this.lives.calcTimeLeft() > 0) {
        this.lottery = false;
        this.setTimer(new cleverapps.CountDown(this.lives.calcTimeLeft(), { onFinish: this.updateAll.bind(this) }), false);
    }

    if (this.onChangeTimer) {
        this.onChangeTimer(!!this.timer === !!timer);
    }
    if (this.onRefreshTimer && this.timer) {
        this.onRefreshTimer();
    }
};

LivesMenuBarItemModel.prototype.getCurrentValue = function () {
    let time;

    if (this.hasUnlimitedLives()) {
        time = Date.now() + cleverapps.unlimitedLives.getLeftTime();
    }

    return {
        amount: cleverapps.lives.amount - cleverapps.pendingRewards.get("lives"),
        total: cleverapps.lives.getMaxLives(),
        time
    };
};